import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { ImgBlock } from "./ImgBlock";
import { LineBlock } from "./LineBlock";
import { LogoBlock } from "./LogoBlock";
import { PBlock } from "./PBlock";
import { PrimaryButtonBlock } from "./PrimaryButtonBlock";
import { SecondaryButtonBlock } from "./SecondaryButtonBlock";

export const contentBlocks: BlockExportMapping = {
  p: PBlock,
  primaryButton: PrimaryButtonBlock,
  secondaryButton: SecondaryButtonBlock,
  img: ImgBlock,
  logo: LogoBlock,
  line: LineBlock,
};
